import React from "react";
import { DriveGear } from "@optimusride/client-library/@types/grpc/vehicle_status";

import { GRAY_400, GREEN_500, RED_500 } from "../../common/styles/colors";

export const VEHICLE_COLOR_MAPPING = {
    [DriveGear.FORWARD]: GREEN_500,
    [DriveGear.NEUTRAL]: GREEN_500,
    [DriveGear.REVERSE]: GREEN_500,
    [DriveGear.PARK]: GRAY_400,
    [DriveGear.OFF]: GRAY_400,
    [DriveGear.UNKNOWN]: RED_500,
};

export default ({
    className,
    angle = 0,
    height,
    width,
    vehicleStatusColor = "#1CEE96",
}: {
  className?: string;
  angle?: number;
  height?: number;
  width?: number;
  vehicleStatusColor?: string;
}) => (
    <svg
        viewBox="0 0 37 23"
        height={height}
        width={width}
        className={className}
        style={{ transform: `rotate(${angle}deg)` }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <linearGradient
                id="vehicleMarkerBody"
                x1="10.5"
                y1="22"
                x2="10.5"
                y2="59"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C4C4C4" />
                <stop offset="1" stopColor="#E0E0E0" />
            </linearGradient>
        </defs>
        <rect
            x="1"
            y="21"
            width="19"
            height="35"
            rx="7"
            transform="rotate(-90 1 21)"
            fill="#4299FF"
        />
        <rect
            x="1"
            y="21"
            width="19"
            height="35"
            rx="7"
            transform="rotate(-90 1 21)"
            fill="url(#vehicleMarkerBody)"
        />
        <rect
            x="1"
            y="21"
            width="19"
            height="35"
            rx="7"
            transform="rotate(-90 1 21)"
            stroke="#000"
            strokeWidth="2"
        />
        <path fill="#000" d="M4 0h9v3H4zM4 20h9v3H4zM23 0h9v3h-9zM23 20h9v3h-9z" />
        <circle
            cx="22.5"
            cy="11.5"
            r="5"
            fill={vehicleStatusColor}
            stroke="#0F0F0F"
        />
        <path
            d="M30 5.571c0-.315.256-.571.571-.571A3.429 3.429 0 0134 8.429v6.142A3.429 3.429 0 0130.571 18a.571.571 0 01-.571-.571V5.57z"
            fill="#677580"
        />
    </svg>
);
